// eslint-disable-next-line check-file/folder-naming-convention
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_redirects/')({
  component: RouteComponent,
  loader: () => {
    throw redirect({
      to: '/assets',
    })
  },
})

function RouteComponent() {
  return <div>Hello &quot;/_redirects/&quot;!</div>
}
